import Provider, { stringifyJson } from "../api/provider";
import { isNullOrEmpty } from "../common/common";

export const returnResponseStatus = (response: any) => {
  if (isNullOrEmpty(response) || isNullOrEmpty(response.data) || isNullOrEmpty(response.data.code) || (response.data.code !== 200 && response.data.code !== 404)) {
    return false;
  }
  return true;
};

export const getAPI = (baseUrl: string | undefined, apiUrl: string, params: any, callback?: any, failureCallback?: any) => {
  Provider.getAll(baseUrl, `${apiUrl}?${new URLSearchParams(stringifyJson(params))}`)
    .then((response: any) => {
      if (returnResponseStatus(response)) {
        if (callback) {
          callback(response.data);
        }
      } else {
        if (failureCallback) {
          failureCallback(response.data);
        }
      }
    })
    .catch((e) => {
      if (failureCallback) {
        failureCallback(e);
      }
    });
};

export const getAPIAsync = async (baseUrl: string | undefined, apiUrl: string, params: any, callback?: any, failureCallback?: any) => {
  await Provider.getAllAsync(baseUrl, `${apiUrl}?${new URLSearchParams(stringifyJson(params))}`)
    .then((response: any) => {
      if (returnResponseStatus(response)) {
        if (callback) {
          callback(response.data);
        }
      } else {
        if (failureCallback) {
          failureCallback(response.data);
        }
      }
    })
    .catch((e) => {
      if (failureCallback) {
        failureCallback(e);
      }
    });
};

export const deleteAPIAsync = async (baseUrl: string | undefined, apiUrl: string, params: any, callback?: any, failureCallback?: any) => {
  await Provider.deleteAsync(baseUrl, apiUrl, params)
    .then((response: any) => {
      if (returnResponseStatus(response)) {
        if (callback) {
          callback(response.data);
        }
      } else {
        if (failureCallback) {
          failureCallback(response.data);
        }
      }
    })
    .catch((e) => {
      if (failureCallback) {
        failureCallback(e);
      }
    });
};

export const postAPIAsync = async (baseUrl: string | undefined, apiUrl: string, params: any, callback?: any, failureCallback?: any) => {
  await Provider.postAsync(baseUrl, apiUrl, params)
    .then((response: any) => {
      if (response.data && response.data.code === 200) {
        if (callback) {
          callback(response.data);
        }
      } else {
        if (failureCallback) {
          failureCallback(response.data);
        }
      }
    })
    .catch((e) => {
      if (failureCallback) {
        failureCallback(e);
      }
    });
};

export const putAPIAsync = async (baseUrl: string | undefined, apiUrl: string, params: any, callback?: any, failureCallback?: any) => {
  await Provider.putAsync(baseUrl, apiUrl, params)
    .then((response: any) => {
      if (response.data && response.data.code === 200) {
        if (callback) {
          callback(response.data);
        }
      } else {
        if (failureCallback) {
          failureCallback(response.data);
        }
      }
    })
    .catch((e) => {
      if (failureCallback) {
        failureCallback(e);
      }
    });
};
